import { ThemeProvider } from "@/components/layout/theme-provider";

function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
      {children}
    </ThemeProvider>
  );
}

export default RootLayout;
